module.exports = __webpack_public_path__ + "static/media/ico-info.e52723d9.svg";